import ModalBase from '../ModalBase/ModalBase';

export function UpgradeSubscriptionForAudiosModal({ isOpen, toggle }) {
  return (
    <ModalBase
      isOpen={isOpen}
      toggle={toggle}
      header={<>Upgrade to play audio</>}
      body={
        <>
          This study method is only for active users with annual or semi-annual
          subscriptions.
        </>
      }
      footer={
        <button className="btn modal-base-btn primary" onClick={toggle}>
          {' '}
          Ok{' '}
        </button>
      }
    />
  );
}
